import { Injectable } from '@angular/core';

import { IconName } from '@fortawesome/fontawesome-svg-core';

import { NavigationItem } from '@models/navigation-item.interface';
import { AppShellConfig } from '@interfaces/app-shell.interface';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly mainNav: NavigationItem[] = [
    { label: 'Dashboard', route: '/dashboard', icon: 'house' as IconName },
    { label: 'Líneas', route: '/lineas', icon: 'sliders' as IconName },
    { label: 'Configuración paquetes', route: '/configuracion-paquetes', icon: 'boxes-stacked' as IconName },
    { label: 'Solicitudes cotización', route: '/solicitudes-cotizacion', icon: 'file-lines' as IconName },
    { label: 'Nuevas garantías', route: '/nuevas-garantias', icon: 'shield-plus' as IconName },
    { label: 'Garantías activas', route: '/garantias-activas', icon: 'shield-check' as IconName },
  ];

  getNavigationItems(): NavigationItem[] {
    return this.mainNav;
  }

  getAppShellConfig(): AppShellConfig {
    return {
      appName: 'Avalservi',
      footerText: '© Avalservi — Administración de garantías Corecredit',
    };
  }
}
